import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const ImageFrame = ({
  src,
  alt,
  caption,
  ratio = "aspect-[4/5]",
  parallax = true,
  dark = false,
  tone = "editorial",
  position = "center",
  className = "",
  testId,
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);
  const toneCls =
    tone === "bw"
      ? "img-editorial-bw"
      : tone === "soft"
        ? "img-editorial-soft"
        : tone === "none"
          ? ""
          : "img-editorial";

  return (
    <figure ref={ref} className={`relative ${className}`}>
      <div className={`relative overflow-hidden border ${dark ? "border-darkborder" : "border-sand"} ${ratio}`}>
        {parallax ? (
          <motion.img
            src={src}
            alt={alt}
            data-testid={testId}
            style={{ y, objectPosition: position }}
            className={`${toneCls} absolute inset-0 h-full w-full scale-[1.18] object-cover`}
          />
        ) : (
          <img
            src={src}
            alt={alt}
            data-testid={testId}
            loading="lazy"
            style={{ objectPosition: position }}
            className={`${toneCls} absolute inset-0 h-full w-full object-cover`}
          />
        )}
      </div>
      {caption && (
        <figcaption
          className={`mt-3 font-mono text-[11px] uppercase tracking-[0.2em] ${dark ? "text-[#575752]" : "text-muted"}`}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default ImageFrame;
